module.exports = __webpack_public_path__ + "img/logo.ccf3a188.png";